import __var_0__ from './median.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Beta distribution median.
*
* @module @stdlib/stats/base/dists/beta/median
*
* @example
* var median = require( '@stdlib/stats/base/dists/beta/median' );
*
* var v = median( 1.0, 1.0 );
* // returns 0.5
*
* v = median( 4.0, 12.0 );
* // returns ~0.239
*
* v = median( 8.0, 2.0 );
* // returns ~0.820
*/

// MODULES //
var median = __var_0__;


// EXPORTS //
export default median;
